/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'support';
const componentName = 'tech-support-list-page';
const prefix = `${moduleName}.${componentName}`;

export const columnTitleCreationDate = `${prefix}.columnTitleCreationDate`;
export const columnTitleResourceName = `${prefix}.columnTitleResourceName`;
export const columnTitleSize = `${prefix}.columnTitleSize`;
export const columnTitleResults = `${prefix}.columnTitleResults`;
export const columnTitleSupportCase = `${prefix}.columnTitleSupportCase`;
export const completedPackagesGridLabel = `${prefix}.completedPackagesGridLabel`;
export const downloadPackageLabel = `${prefix}.downloadPackageLabel`;
export const errorLogLabel = `${prefix}.errorLogLabel`;
export const fileNameLabel = `${prefix}.fileNameLabel`;
export const generateButtonLabel = `${prefix}.generateButtonLabel`;
export const headerLabel = `${prefix}.headerLabel`;
export const inProgressLabel = `${prefix}.inProgressLabel`;
export const completedLabel = `${prefix}.completedLabel`;
export const errorLabel = `${prefix}.errorLabel`;
export const completedWithWarningsLabel = `${prefix}.completedWithWarningsLabel`;
export const warningLabel = `${prefix}.warningLabel`;
export const viewReportLabel = `${prefix}.viewReportLabel`;
export const debugLogsLabel = `${prefix}.debugLogsLabel`;
export const clusteringLabel = `${prefix}.clusteringLabel`;
export const gslbLabel = `${prefix}.gslbLabel`;
export const metricsLogsLabel = `${prefix}.metricsLogsLabel`;
export const placementLabel = `${prefix}.placementLabel`;
export const portalLabel = `${prefix}.portalLabel`;
export const loadingRecentLabel = `${prefix}.loadingRecentLabel`;
export const fileNotFoundErrorLabel = `${prefix}.fileNotFoundErrorLabel`;

export const ENGLISH = {
    [columnTitleCreationDate]: 'Creation Date',
    [columnTitleResourceName]: 'Resource Name',
    [columnTitleSize]: 'Size (MB)',
    [columnTitleResults]: 'Results',
    [columnTitleSupportCase]: 'Support Case',
    [completedPackagesGridLabel]: 'Tech Support Packages ({0})',
    [downloadPackageLabel]: 'Download Package',
    [errorLogLabel]: 'Error Log',
    [fileNameLabel]: 'File Name',
    [generateButtonLabel]: 'Generate',
    [headerLabel]: 'Tech Support',
    [inProgressLabel]: 'In Progress',
    [completedLabel]: 'Completed Successfully',
    [errorLabel]: 'Failed',
    [completedWithWarningsLabel]: 'Completed With Warnings',
    [warningLabel]: 'Warning',
    [viewReportLabel]: 'View Report',
    [debugLogsLabel]: 'Debug Logs',
    [clusteringLabel]: 'Clustering',
    [gslbLabel]: 'GSLB',
    [metricsLogsLabel]: 'Metrics Logs',
    [placementLabel]: 'Placement',
    [portalLabel]: 'Portal',
    [loadingRecentLabel]: 'Loading Recent',
    [fileNotFoundErrorLabel]: 'The tech support package file is not available for download.',
};
